import Tabs from "@mui/material/Tabs";

export default Tabs;
